module.exports = __webpack_public_path__ + "img/recommendation.3144b47e.png";